export default __webpack_public_path__ + "static/media/undraw_confirmation_2uy0 (1).de3a5c1f.svg";